import './styles.css';
import { renderGenerateCodesPage } from './generate-codes-page';
import { renderPrivacyPage, renderTermsPage } from './legal-pages';
import { renderResultsPage } from './results-page';
import { renderLandingPage } from './landing-page';
import { renderBiasPage } from './bias-page';
import { renderSurveyPage } from './survey-page';
import { renderSupportOverTimePage } from './support-over-time-page';
import { renderPublicResultsDashboardPage } from './public-results-dashboard-page';
import { renderAnalysisPage } from './analysis-page';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Application root is missing.');

root.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const dialog = root.querySelector<HTMLDialogElement>('[data-about-dialog]');
  if (target.closest('[data-about-open]')) dialog?.showModal();
  if (target.closest('[data-about-close]') || target === dialog) dialog?.close();
});

const route = window.location.pathname.replace(/\/$/, '') || '/';
const render = route === '/' ? () => renderLandingPage(root)
  : route === '/results-dashboard' ? () => renderResultsPage(root)
    : route === '/public-results-dashboard' ? () => renderPublicResultsDashboardPage(root)
    : route === '/results-map' ? () => import('./results-map-page').then(({ renderResultsMapPage }) => renderResultsMapPage(root))
      : route === '/results-map-dev' ? () => import('./results-map-dev-page').then(({ renderResultsMapDevPage }) => renderResultsMapDevPage(root))
        : route === '/bias' ? () => renderBiasPage(root)
          : route === '/support-over-time' ? () => renderSupportOverTimePage(root)
          : route === '/example' ? () => renderSurveyPage(root, { example: true })
            : route === '/analysis' ? () => renderAnalysisPage(root)
      : route === '/generate-codes' ? () => renderGenerateCodesPage(root)
        : route === '/given-tracker' ? () => import('./tracker-page').then(({ renderTrackerPage }) => renderTrackerPage(root))
          : route === '/privacy' ? () => renderPrivacyPage(root)
            : route === '/terms' ? () => renderTermsPage(root)
              : () => {
                root.innerHTML = '<main class="not-found"><p class="eyebrow">404</p><h1>Page not found</h1><a class="primary-button" href="/">Return to the survey</a></main>';
              };

void render();
